import de from '@translations/de/brands.json';
import en from '@translations/en/brands.json';
import pl from '@translations/pl/brands.json';
import sl from '@translations/sl/brands.json';
import uk from '@translations/uk/brands.json';
import bg from '@translations/bg/brands.json';
import cz from '@translations/cz/brands.json';
import fr from '@translations/fr/brands.json';
import gr from '@translations/gr/brands.json';
import it from '@translations/it/brands.json';
import pr from '@translations/pr/brands.json';
import ru from '@translations/ru/brands.json';
import sk from '@translations/sk/brands.json';
import sp from '@translations/sp/brands.json';
import tr from '@translations/tr/brands.json';
import hu from '@translations/hu/brands.json';
import { ITranslations } from '@/types/common';
import { BrandsTransFields } from './types';

export const brandsTranslations: ITranslations<BrandsTransFields> = {
  name: 'brands',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
